<template>
  <form>
    <div id="div-appointment-detail" class="vs-con-loading__container">

      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
          <div>
            <vs-textarea label="Diagnósticos" cols="50" v-model="data.diagnostics"/>
          </div>
        </vs-col>
      </vs-row>

      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
          <label for class="vs-input-label">Motivo da consulta</label>
        </vs-col>

        <vs-col vs-type="flex" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
          <quill-editor v-model="data.appointmentReason"></quill-editor>
        </vs-col>
      </vs-row>

      <br />

      <vs-row vs-w="12">
        <div>
          <vs-col vs-type="flex" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
            <label for class="vs-input-label">História Clínica e Alimentar</label>
          </vs-col>

          <vs-col vs-type="flex" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
            <quill-editor v-model="data.clinicAndDietaryHistory"></quill-editor>
          </vs-col>
        </div>
      </vs-row>

      <br />

      <vs-row>
        <vs-col vs-type="flex" vs-align="right" vs-lg="12" vs-sm="12" vs-xs="12">
          <vs-button @click="submit">Salvar</vs-button>
        </vs-col>
      </vs-row>
    </div>
  </form>
</template>

<script>
// QuillEditor
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";

import AppointmentService from "../../../services/AppointmentService";

export default {
  components: {
    quillEditor
  },
  props: {
    idAppointment: {
      required: true
    },
  },
  data() {
    return {
      data: {
        id: 0,
        idAppointment: 0,
        diagnostics: "",
        appointmentReason: "",
        clinicAndDietaryHistory: "",
        medicalConduct: "",
        description: "",
      },
      notifications: {
        notify: this.$vs.notify,
        dialog: this.$vs.dialog,
        errors: this.errors,
        showSucces: false,
        showError: true
      },
      defaultDivId: "div-appointment-detail",
    };
  },
  mounted: function() {
    this.get();
    this.data.idAppointment = this.$props.idAppointment;
  },
  beforeDestroy: function() {
    this.submit();
  },
  methods: {
    async submit() {
      if (this.data.id != null && this.data.id > 0) {
        this.update();
      } else {
        this.create();
      }
    },
    async get() {
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: {
          idAppointment: this.$props.idAppointment
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = false;
      payload.notifications.showError = false;
      
      var result = await AppointmentService.get(payload);
      if (result.status == 200) {
        if (result.data.result != null) {
          this.data = result.data.result;
        }
      }

      this.closeLoadingDiv(this.defaultDivId);
    },
    async create() {
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: this.data,
        notifications: this.notifications
      };

      payload.notifications.showSucces = true;
      payload.notifications.showError = true;

      await AppointmentService.create(payload);

      this.closeLoadingDiv(this.defaultDivId);
    },
    async update() {
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: this.data,
        notifications: this.notifications
      };

      payload.notifications.showSucces = true;
      payload.notifications.showError = true;

      await AppointmentService.update(payload);

      this.closeLoadingDiv(this.defaultDivId);
    },
    openLoadingInDiv(divId) {
      this.$vs.loading({
        container: "#" + divId,
        scale: 0.6
      });
    },
    closeLoadingDiv(divId) {
      this.$vs.loading.close("#" + divId + " > .con-vs-loading");
    },
  }
};
</script>

<style scoped>
.label {
  padding-left: 5px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.7);
}
</style>